import { jwtDecode } from 'jwt-decode';

const MS_IN_SEC = 1000;

export class AccessToken {
  protected readonly _encodedAccessToken: string;
  protected readonly _decodedAccessToken: DecodedAccessToken;

  /**
   * Raw value of access token.
   *
   * Passed in constructor when creating AccessToken instance.
   */
  get encodedAccessToken(): string {
    return this._encodedAccessToken;
  }

  /**
   * Token expiration timestamp (in milliseconds passed since unix epoch)
   */
  get expirationTimeMs(): number {
    return this._decodedAccessToken.exp * MS_IN_SEC;
  }

  /**
   * Time until token expiration from Date.now (in milliseconds)
   */
  get timeToExpirationMs(): number {
    // current time in ms passed since unix epoch
    const currentTimeMs = Math.floor(Date.now());

    return this.expirationTimeMs - currentTimeMs;
  }

  constructor(accessToken: string) {
    this._encodedAccessToken = accessToken;
    // accessToken (and therefore decodedAccessToken) contains much more info than expiration time (exp)
    // but since (at the moment) exp is the only required property, it is the only property being typed
    const decodedAccessToken = jwtDecode<{ exp: number }>(accessToken);

    this._decodedAccessToken = {
      exp: decodedAccessToken.exp,
    };
  }
}

interface DecodedAccessToken {
  exp: number;
}
